import { SIZES } from '@consts/index'
import { objectKeys } from '@helpers/utils'

const SIZE_FILTER_TYPES = new Set(
  objectKeys(SIZES).map(key => key.toString().toLowerCase())
)

export function isSizeFilterType(type: string) {
  return SIZE_FILTER_TYPES.has(type.toLowerCase())
}
